import { render, staticRenderFns } from "./Top5.vue?vue&type=template&id=7c36c0a0&scoped=true&"
import script from "./Top5.vue?vue&type=script&lang=js&"
export * from "./Top5.vue?vue&type=script&lang=js&"
import style0 from "./Top5.vue?vue&type=style&index=0&id=7c36c0a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c36c0a0",
  null
  
)

export default component.exports